class SuperhostInputFormatter {
  formatField = (field, input) => {
    switch (field) {
      case 'vimeo_url':
        return this.convertVimeoInputToUid(input)
      case 'zoom_uid':
        return this.convertZoomInputToUid(input)
      default:
        return input;
    }
  }

  convertVimeoInputToUid = (input) => {
    // return ((`${input}` || '').replace(/[\s]/g, '').match(/\d{5,}/) || [])[0] || input
    return input;
  }

  convertZoomInputToUid = (input) => {
    return ((`${input}` || '').replace(/[\s-]/g, '').match(/\d{5,}/) || [])[0] || input
  }
}

export default (new SuperhostInputFormatter())



// WEBPACK FOOTER //
// ./src/services/superhostInputFormatter.js